import React from 'react'
import ButtonGroup from '@components/common/ButtonGroup/ButtonGroup.component'
import TemplateItemPreview from './TemplateItemPreview.component'
import useTemplateList from './useTemplateList'
import './TemplateListStyle.css'
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons'
import MarketingDeleteCampaignTemplateModal from '../../MarketingDeleteCampaignTemplateModal.component'

const TemplateList: React.FC = () => {
  const hooks = useTemplateList()

  return (
    <>
      <div className="mt-template-list-component">
        <ButtonGroup
          buttons={[
            { label: 'SMS', value: 'SMS' },
            { label: 'Email', value: 'Email' },
          ]}
          activeTab={hooks.activeChannel}
          onButtonClick={hooks.handleChangeChannel}
        />
        <div className="mt-built-in-template">
          <div className="mt-header">Templates</div>
          <div className="mt-template-list">
            {hooks.builtInTemplates.map((template) => (
              <div
                key={template.campaign_template_id}
                className="mt-template-item"
                role="button"
                tabIndex={0}
                aria-label={template.name}
                onClick={() => hooks.handleSelectTemplate(template)}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter' && e.key !== ' ') return
                  e.preventDefault()
                  hooks.handleSelectTemplate(template)
                }}
              >
                <TemplateItemPreview template={template} />
                <div className="mt-template-item-text">
                  <div className="title">{template.name}</div>
                  <div className="description">{template.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-saved-template">
          <div className="mt-header">Saved templates</div>
          <div className="mt-template-list">
            <div
              key="add-new-saved-template"
              className="mt-template-item"
              role="button"
              tabIndex={0}
              aria-label="Create a new template"
              onClick={() => hooks.handleCreateNewTemplate()}
              onKeyDown={(e) => {
                if (e.key !== 'Enter' && e.key !== ' ') return
                e.preventDefault()
                hooks.handleCreateNewTemplate()
              }}
            >
              <div className="mt-template-item-preview mt-add-new-template mgc_add_circle_fill"></div>
              <div className="mt-template-item-text">
                <div className="title">Create a new template</div>
                <div className="description">Create a custom template</div>
              </div>
            </div>
            {hooks.savedTemplates.map((template) => (
              <div
                key={template.campaign_template_id}
                className="mt-template-item"
                role="button"
                tabIndex={0}
                aria-label={template.name}
                onClick={() => hooks.handleSelectTemplate(template)}
                onKeyDown={(e) => {
                  if (e.key !== 'Enter' && e.key !== ' ') return
                  e.preventDefault()
                  hooks.handleSelectTemplate(template)
                }}
              >
                <TemplateItemPreview template={template} />
                <div className="mt-template-item-text">
                  <div className="title">{template.name}</div>
                  <div className="mt-template-item-desc-row">
                    <div className="description">{template.description}</div>
                    <DropDownButtonComponent
                      cssClass="e-caret-hide mt-template-dropdown"
                      iconCss="mgc_more_2_fill"
                      items={[
                        {
                          text: 'Edit',
                          iconCss: 'mgc_pencil_fill',
                          id: 'edit',
                        },
                        {
                          text: 'Delete',
                          iconCss: 'mgc_delete_2_fill',
                          id: 'delete',
                        },
                      ]}
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      select={(e) => {
                        hooks.handleDropdownClick(template, e)
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <MarketingDeleteCampaignTemplateModal
        show={hooks.showDeleteModal}
        templateName={hooks.selectedTemplate?.name ?? ''}
        onCancel={hooks.onHideDeleteModal}
        onDelete={hooks.handleDeleteTemplate}
      />
    </>
  )
}

export default TemplateList
